import { redirect } from 'react-router-dom'
import { defer, LoaderFunction, ActionFunction } from 'react-router-typesafe'
import { useQsAdminApiManager } from '@/auth/api/qsadminapiManager'
import { RoleRouteObject, RouteFunctionParams } from '@/types'
import { entita_aziendale, azienda } from '@/model/qsadminapi/QsAdminApiModuleModel'
import EntityCreator from '@/routes/contacts/entity/EntityCreator'
import { Roles } from '@/auth/azure/Roles'
import { getAzureUserInformation } from '@/auth/azure/azureManager'
import { ODataModelResponseV4 } from '@odata2ts/odata-core'
import { HttpResponseModel } from '@odata2ts/http-client-api'
import { AxiosResponse } from 'axios'
import { createDescriptor } from '@/components/BreadCrumbs/BreadCrumbs'

export const entityCreatorRouteLoader = (async ({ params }: RouteFunctionParams<'clientId'>) => {
  const qsAdminApi = useQsAdminApiManager.getState().service
  const clientId = params.clientId
  let azienda: HttpResponseModel<ODataModelResponseV4<azienda>> | undefined
  if (clientId)
    azienda = await qsAdminApi.azienda(Number(clientId)).query((builder, azienda) => {
      builder.select('id', 'nome')
    })
  const title = azienda ? `${azienda.data.nome} - Nuovo contatto` : 'Nuovo contatto'
  const contact: entita_aziendale = {
    id: 0,
    note: null,
    nome: null,
    telefono: null,
    emails: [
      {
        id: 0,
        email: null,
        note: null,
        rif_ad: false,
      },
    ],
    ad_recipient: false,
    hasLinkedObjects: false,
    ricezione_rapportino: false,
    created_at: null,
    updated_at: null,
  }
  const getAziende = qsAdminApi.azienda().query((builder, qazienda) => {
    builder.orderBy(qazienda.nome.asc())
    builder.select('id', 'nome')
    builder.filter(qazienda.sedi.any())
    builder.filter(clientId ? qazienda.id.eq(Number(clientId)) : null)
  })

  return defer({
    title,
    contact,
    getAziende,
    getUserInfo: getAzureUserInformation(),
  })
}) satisfies LoaderFunction

const entityCreatorRouteAction = (async ({ request }: RouteFunctionParams) => {
  const qsAdminApi = useQsAdminApiManager.getState().client
  const contact = (await request.json()) as entita_aziendale
  // const res = await qsAdminApi.contatto_aziendale().create(contact)
  const response: AxiosResponse<entita_aziendale, entita_aziendale> = await qsAdminApi.post(
    'api/entitaaziendale/create',
    { contact },
    {
      headers: { 'Content-Type': 'application/json' },
    },
  )
  return redirect(`..`)
}) satisfies ActionFunction

const EntityCreatorRoute = {
  path: 'new',
  element: <EntityCreator />,
  loader: entityCreatorRouteLoader,
  action: entityCreatorRouteAction,
  allowedRoles: [Roles.Guest],
  handle: {
    crumb: () => createDescriptor,
  },
} as RoleRouteObject

export default EntityCreatorRoute
